export const AUTH_TOKEN_CHANGED_EVENT = 'auth-token-changed';
const LEFTOVER_STORAGE_KEY = 'token';

let cookieSession = false;

function discardLeftoverStorageToken(): void {
  if (typeof localStorage === 'undefined') return;
  if (localStorage.getItem(LEFTOVER_STORAGE_KEY) != null) {
    localStorage.removeItem(LEFTOVER_STORAGE_KEY);
  }
}

function notifyAuthChanged(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(AUTH_TOKEN_CHANGED_EVENT));
  }
}

export function getAuthToken(): string | null {
  discardLeftoverStorageToken();
  return null;
}

export function setAuthToken(_token: string): void {
  markCookieSession(true);
}

export function markCookieSession(active: boolean): void {
  discardLeftoverStorageToken();
  const changed = cookieSession !== active;
  cookieSession = active;
  if (changed) notifyAuthChanged();
}

export function clearAuthToken(): void {
  discardLeftoverStorageToken();
  const changed = cookieSession;
  cookieSession = false;
  if (changed) notifyAuthChanged();
}

export function hasSession(): boolean {
  discardLeftoverStorageToken();
  return cookieSession;
}
